import { Box, Container, Typography, ButtonGroup, Button, LinearProgress, SpeedDial, useMediaQuery } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router";
import AddIcon from '@mui/icons-material/Add';
import ListRolesComponent from "../components/ListRolesComponent";
import { useAuth } from "../../../../shared/context/authContext";
import { useEffect } from "react";
import { useAbility } from "../../../../shared/context/AbilityContext";

export default function ListRolesView() {
    const theme = useTheme();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 600px)');

    const { setRoleUser, setPermissions, getAllRoles, roles, loadingGetRoles } = useAuth();


    useEffect(() => {
        setRoleUser({
            name: '',
            description: '',
        });
        setPermissions([]);
        getAllRoles();
    }, []);

    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('read', 'ROLES')) {
            navigate('/')
        }
    }, [ability])

    return (
        <Container maxWidth="xl" disableGutters sx={{
            padding: '0px', margin: '0px',
        }}>
            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: '10px 20px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '20px',
                }}>
                    Lista de Roles
                </Typography>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }}>

               

                </Box>

                {loadingGetRoles && <LinearProgress />}
                <ListRolesComponent roles={roles} loadingGetRoles={loadingGetRoles} />

                <SpeedDial
                    ariaLabel="Add"
                    sx={{ position: 'absolute', bottom: isMobile ? 80 : 30, right: 8 }}
                    icon={<AddIcon />}
                    direction="right"
                    openIcon={<AddIcon />}
                    onClick={() => navigate('/rrhh/roles/crear')}
                />
            </Box>
        </Container>
    )
}